import { render } from "./modulesIcon.vue?vue&type=template&id=7f91370e"
import script from "./modulesIcon.vue?vue&type=script&lang=js"
export * from "./modulesIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__